import Vue from 'vue'
import store from '@store'


Vue.prototype.$getErrors = function(key) {

    var fallback = this.$page 
    ? _.get(this.$page.props.errors, key, [])
    : []

    return _.get(
        store.state.app.errors,
        key,
        fallback
    )
}

Vue.prototype.$hasErrors = function(key) {

    var fallback = this.$page 
    ? _.get(this.$page.props.errors, key, [])
    : []

    return _.get(
        store.state.app.errors,
        key,
        fallback
    ).length

}

Vue.prototype.$setProfile = function(payload, notification = true) {

    return new Promise((resolve, reject) => {

        return axios.post(route('account.profile.set'), payload)
        .then(response => {

            this.$store.commit(
                'app/setAuth', response.data
            )

            this.$flash(this.$t('profile.Profile updated'))

            resolve(response.data)

        }).catch(error => {
            this.$flash(this.$t('app.An error has occured'))
            reject(error)
        })

    })

}



Vue.prototype.$setSettings = function(payload, notification = true) {

    return new Promise((resolve, reject) => {

        var settings = store.state.app.auth.settings

        _.each(payload, (value, key) => {
            settings[key] = value
        })

        return axios.post(route('account.profile.set'), {
            settings: settings
        })
        .then(response => {

            this.$store.commit(
                'app/setAuth', response.data
            )

            this.$flash('Profil mis à jour')

            resolve(response.data)

        }).catch(error => {
            this.$flash("Une erreur s'est produite")
            reject(error)
        })

    })

}

Vue.prototype.$_ = _